<template>
  <div>
    <div class="row">
    <h1 class="col-8 primary-text">{{ title }}</h1>
    <div class="col-4 text-left "><span class="primary-text ml-2 pointer" @click="goToProductList">MORE</span> <i
        class="fa-solid fa-arrow-left fa-lg pointer"></i></div>
    </div>
    <div v-if="dataLoading" class="row align-items-center ">
      <div class="col-6 text-center pl-1">
        <v-skeleton-loader
            dir="ltr"
            type=" image, list-item-avatar"
        ></v-skeleton-loader>
      </div>
      <div class="col-6 text-center pr-1">
        <v-skeleton-loader
            dir="ltr"
            type=" image, list-item-avatar"
        ></v-skeleton-loader>
      </div>
    </div>
    <div v-else-if="products.length > 0 && products !== undefined" class="row">


      <div class="col-12" dir="ltr">
        <carousel
            v-if="products.length >0"
            :autoplay="false"
            :autoplayTimeout="7000"
            :dots="false"
            :margin="8"
            :nav="true"
            :navText="navText"
            :responsive="{0:{items:2},1200:{items:3},}"
            :rtl="true"
            class="owl-carousel-post-card">
          <div v-for="item in products" :key="item.id">
            <ProductCard :item="item"/>
          </div>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";
import ProductCard from "@/components/ProductCard";

export default {
  name: "ProductsCarousel",
  props: ['products', 'title', 'dataLoading', 'isOnline', 'type'],
  components: {
    ProductCard,
    carousel,
  },
  data: () => ({
    navText: ['<i class="fa-solid fa-circle-chevron-left" aria-hidden="true"></i>'],
    isOnlinePayment: null
  }),
  mounted() {
    if (this.isOnline === 'true') {
      this.isOnlinePayment = true
    } else if (this.isOnline === 'false') {
      this.isOnlinePayment = false
    }
  },
  methods: {
    goToProductList() {
      this.$router.push({path: 'ProductsList', query: {isOnline: this.isOnlinePayment, type: this.type}})
    }
  }
}
</script>

<style scoped>

</style>
